import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faMedium } from "@fortawesome/free-brands-svg-icons";

import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

import {
  Container,
  TimelineContainer,
  TimelineLogo,
  BigText,
  Text,
  RecentWorks,
  RecentWork,
  Works,
  DeprecatedText,
  ExploratoryProjects,
  ProjectCard,
  ProjectImage,
  ProjectTitle,
  ProjectDescription,
  MyWork,
  MoreWork,
  Medium,
  ProjectLink,
  ProjectRepository,
} from "./work";

import AIden from "../../images/screenshots/aiden.png";
import Netflix from "../../images/screenshots/netflix.png";
import Powwow from "../../images/screenshots/powwow.png";
import Daxi from "../../images/screenshots/daxi.png";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import nu from "../../images/educations/nu.jpeg";
import nugig from "../../images/companies/nugig.jpeg";
import philips from "../../images/companies/philips.jpeg";
import zoho from "../../images/companies/zoho.jpeg";
import kloudone from "../../images/companies/kloudone.jpeg";
import tactii from "../../images/companies/tactii.jpeg";
import au from "../../images/educations/au.jpeg";

export default function Work() {
  return (
    <>
      <Container>
        <BigText>My Experience and Education!</BigText>
        <TimelineContainer>
          <VerticalTimeline lineColor={"#d6d6d6"}>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ color: "black" }}
              date="Aug 2022 - May 2024"
              dateClassName="vertical-timeline-element--date"
              iconStyle={{ background: "black", color: "#d6d6d6" }}
              icon={<TimelineLogo src={nu} alt="Northeastern University" />}
            >
              <h4 className="vertical-timeline-element-title">
                Master's in Computer Science
              </h4>
              <h5 className="vertical-timeline-element-subtitle">
                Northeastern University | Boston, MA
              </h5>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ color: "black" }}
              date="Aug 2022 - Present"
              dateClassName="vertical-timeline-element--date"
              iconStyle={{ background: "black", color: "#d6d6d6" }}
              icon={<TimelineLogo src={nugig} alt="IoT Open Innovation Lab" />}
            >
              <h4 className="vertical-timeline-element-title">
                Program Manager & Senior Research Assistant Engineer
              </h4>
              <h5 className="vertical-timeline-element-subtitle">
                IoT Open Innovation Lab at Northeastern University | Boston, MA
              </h5>
              <p>
                <b>
                  JavaScript · Vue.js · FastAPI · PostgreSQL · SQLAlchemy ·
                  Docker · Amazon Web Services (AWS) · Program Management
                </b>
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ color: "black" }}
              date="Jul 2023 - Dec 2023"
              dateClassName="vertical-timeline-element--date"
              iconStyle={{ background: "black", color: "#d6d6d6" }}
              icon={<TimelineLogo src={philips} alt="Philips" />}
            >
              <h4 className="vertical-timeline-element-title">
                Software Engineer Co-op
              </h4>
              <h5 className="vertical-timeline-element-subtitle">
                Philips Healthcare | Cambridge, MA
              </h5>
              <p>
                <b>
                  CI/CD · Docker · Kubernetes · Amazon Web Services (AWS) ·
                  ArgoCD · Rancher · Helm Charts · Prometheus · Grafana
                </b>
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ color: "black" }}
              date="Jan 2022 - Aug 2022"
              dateClassName="vertical-timeline-element--date"
              iconStyle={{ background: "black", color: "#d6d6d6" }}
              icon={<TimelineLogo src={zoho} alt="Zoho" />}
            >
              <h4 className="vertical-timeline-element-title">
                Member Technical Staff
              </h4>
              <h5 className="vertical-timeline-element-subtitle">
                Zoho Corporation | Chennai, India
              </h5>
              <p>
                <b>
                  Java · Struts2 · JavaScript · Microservices · PostgreSQL ·
                  MySQL · REST APIs · CRM Integration
                </b>
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ color: "black" }}
              date="Sep 2018 - May 2022"
              dateClassName="vertical-timeline-element--date"
              iconStyle={{ background: "black", color: "#d6d6d6" }}
              icon={<TimelineLogo src={au} alt="Anna University" />}
            >
              <h4 className="vertical-timeline-element-title">
                Bachelor's in Computer Science & Engineering
              </h4>
              <h5 className="vertical-timeline-element-subtitle">
                Anna University | Chennai, India
              </h5>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ color: "black" }}
              date="May 2021"
              dateClassName="vertical-timeline-element--date"
              iconStyle={{ background: "black", color: "#d6d6d6" }}
              icon={<TimelineLogo src={zoho} alt="Zoho" />}
            >
              <h4 className="vertical-timeline-element-title">Summer Intern</h4>
              <h5 className="vertical-timeline-element-subtitle">
                Zoho Corporation | Chennai, India
              </h5>
              <p>
                <b>Data Structures · Algorithms · Design Paradigms · Java</b>
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--education"
              contentStyle={{ color: "black" }}
              date="Oct 2020 - Jan 2021"
              dateClassName="vertical-timeline-element--date"
              iconStyle={{ background: "black", color: "#d6d6d6" }}
              icon={<TimelineLogo src={tactii} alt="Tactii" />}
            >
              <h4 className="vertical-timeline-element-title">DevOps Intern</h4>
              <h5 className="vertical-timeline-element-subtitle">
                Tactii | Ontario, Canada (Remote)
              </h5>
              <p>
                <b>
                  FastAPI · Docker · Kubernetes · Linux · CircleCI · Python ·
                  Web Scraping
                </b>
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ color: "black" }}
              date="Jun 2020 - Jan 2021"
              dateClassName="vertical-timeline-element--date"
              iconStyle={{ background: "black", color: "#d6d6d6" }}
              icon={<TimelineLogo src={kloudone} alt="Kloudone" />}
            >
              <h4 className="vertical-timeline-element-title">
                Intern Software Engineer
              </h4>
              <h5 className="vertical-timeline-element-subtitle">
                Kloudone, Inc. | Chennai, India
              </h5>
              <p>
                <b>
                  React.js · TypeScript · GatsbyJS · React Native · Flutter ·
                  Bootstrap (Framework) · REST APIs · Search Engine Optimization
                  (SEO) · Progressive Web Applications (PWAs)
                </b>
              </p>
            </VerticalTimelineElement>
          </VerticalTimeline>
        </TimelineContainer>
        <RecentWorks>
          <Text>I'm proud to have worked on these awesome projects</Text>
          <RecentWork>
            <Works
              href="https://nugig.tech/"
              target="_blank"
              rel="noreferrer"
              className="custom-underline"
            >
              <sup>01</sup>&nbsp;NUGig
            </Works>
          </RecentWork>
          <RecentWork>
            <Works
              href="https://indelibles.art/"
              target="_blank"
              rel="noreferrer"
              className="custom-underline"
            >
              <sup>02</sup>&nbsp;Indelibles
            </Works>
          </RecentWork>
          <RecentWork>
            <Works
              className="custom-underline"
              href="https://kloudlearn.com/"
              target="_blank"
              rel="noreferrer"
            >
              <sup>03</sup>&nbsp;KloudLearn Portfolio
              <sup style={{ fontSize: "1.2em" }}>*</sup>
            </Works>
          </RecentWork>
          <RecentWork>
            <Works
              className="custom-underline"
              href="https://app.kloudlearn.com/"
              target="_blank"
              rel="noreferrer"
            >
              <sup>04</sup>&nbsp;KloudLearn App
              <sup style={{ fontSize: "1.2em" }}>*</sup>
            </Works>
          </RecentWork>
          <RecentWork>
            <Works
              href="https://breadtime-stories.netlify.app/"
              target="_blank"
              rel="noreferrer"
              className="custom-underline"
            >
              <sup>05</sup>&nbsp;Breadtime Stories
            </Works>
          </RecentWork>
          <RecentWork>
            <Works
              href="https://oozytales.netlify.app"
              target="_blank"
              rel="noreferrer"
              className="custom-underline"
            >
              <sup>06</sup>&nbsp;Oozy Tales
            </Works>
          </RecentWork>
          <DeprecatedText>
            <h1 style={{ fontSize: "1.2em", verticalAlign: "super" }}>*</h1> The
            product was deprecated.
          </DeprecatedText>
        </RecentWorks>
        <MyWork>
          <BigText>Exploratory Projects</BigText>
          <ExploratoryProjects>
            <ProjectCard>
              <ProjectImage src={AIden} alt="AI Den" />
              <ProjectTitle>AI Den</ProjectTitle>
              <ProjectDescription>
                A GPT3 based story generation system with a synonymizer and a
                translator built using React and the OpenAI API.
              </ProjectDescription>
              <ProjectLink
                href="https://ai-den.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                Visit Website <FontAwesomeIcon icon={faAngleRight} />
              </ProjectLink>
              <ProjectRepository
                href="https://github.com/shrued/gpt3-fyp"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} />
              </ProjectRepository>
            </ProjectCard>
            <ProjectCard>
              <ProjectImage height={220} src={Netflix} alt="Netflix Clone" />
              <ProjectTitle>Netflix Clone</ProjectTitle>
              <ProjectDescription>
                A Netflix clone with a customized video player using React,
                Redux, Styled Components and Firestore.
              </ProjectDescription>
              <ProjectLink
                href="https://netflix-faec8.web.app/"
                target="_blank"
                rel="noreferrer"
              >
                Visit Website <FontAwesomeIcon icon={faAngleRight} />
              </ProjectLink>
              <ProjectRepository
                href="https://github.com/shrued/netflix"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} />
              </ProjectRepository>
            </ProjectCard>
            <ProjectCard>
              <ProjectImage src={Powwow} alt="Powwow" />
              <ProjectTitle>Powwow</ProjectTitle>
              <ProjectDescription>
                A open-world chatting Progressive Web Application (PWA) built
                with React and Firebase.
              </ProjectDescription>
              <ProjectLink
                href="https://powwow-a9294.web.app/"
                target="_blank"
                rel="noreferrer"
              >
                Visit Website <FontAwesomeIcon icon={faAngleRight} />
              </ProjectLink>
              <ProjectRepository
                href="https://github.com/shrued/powwow"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} />
              </ProjectRepository>
            </ProjectCard>
            <ProjectCard>
              <ProjectImage height={220} src={Daxi} alt="Daxi" />
              <ProjectTitle>Daxi</ProjectTitle>
              <ProjectDescription>
                A React application to help people dealing with mental health
                issues with a mood board tracking board.
              </ProjectDescription>
              <ProjectLink
                href="https://daxi-aabf4.firebaseapp.com/"
                target="_blank"
                rel="noreferrer"
              >
                Visit Website <FontAwesomeIcon icon={faAngleRight} />
              </ProjectLink>
              <ProjectRepository
                href="https://github.com/shrued/daxi"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} />
              </ProjectRepository>
            </ProjectCard>
          </ExploratoryProjects>
        </MyWork>
        <MoreWork
          href="https://github.com/shrued"
          target="_blank"
          rel="noreferrer"
        >
          More on&nbsp;
          <FontAwesomeIcon icon={faGithub} />
        </MoreWork>
        <Medium
          className="medium"
          href="https://medium.com/@shrued"
          target="_blank"
          rel="noreferrer"
        >
          Check out my blogs on&nbsp;
          <FontAwesomeIcon icon={faMedium} />
        </Medium>
      </Container>
    </>
  );
}
